/* eslint-disable import/no-restricted-paths */
import { uploadImage, uploadJSON } from "@/lib/aws-amplify/storage";

import type { IS3Repository, SnackS3Object } from "@CHILLNN-Inc/chillnn-abr-snack/dist/entity/_index";

export class S3Repository implements IS3Repository {
	get #url() {
		let url = import.meta.env.VITE_STORAGE_AWSS3_MASTER_BASE_URL;
		// 末尾のスラッシュを削除
		url = url.slice(-1) === "/" ? url.slice(0, -1) : url;

		return url;
	}

	public async fetchObject<T>(s3Object: SnackS3Object): Promise<T> {
		const url = s3Object.url;

		const res = await fetch(url);

		return res.json();
	}

	public async addImage(uniquePath: string, file: File): Promise<SnackS3Object> {
		const { bucket, key, region } = await uploadImage(uniquePath, file);

		return {
			bucket,
			key,
			url: `${this.#url}/${key}`,
			region,
		} satisfies SnackS3Object;
	}

	public async addJSON<T>(uniquePath: string, object: T): Promise<SnackS3Object> {
		const { bucket, key, region } = await uploadJSON(uniquePath, object);

		return {
			bucket,
			key,
			url: `${this.#url}/${key}`,
			region,
		} satisfies SnackS3Object;
	}
}

export const s3Repository = new S3Repository();
